<!--
  @component
  Generates an SVG Sankey chart using [d3-sankey](https://github.com/d3/d3-sankey).
 -->
<script>
  import { getContext } from "svelte";
  import * as Sankey from "d3-sankey";
  //Funktioniert nicht: import {Sankey} from 'sankey.js'

  const { data, width, height } = getContext("LayerCake");

  export let sticky;
  let sankeyData;

  let breite = 50;
  // let factor = 0.9;

  let schwellwert_verschiebung = 19;

  function my_node_color(d) {
    if ("color" in d) {
      return d["color"];
    }

    return "#6fcdfa";
  }

  function my_link_color(d) {
    if ("color" in d) {
      return d["color"];
    }

    return "rgba(40, 20, 0, .2)";
  }

  // * @type {Function} [colorLinks=d => 'rgba(0, 0, 0, .2)'] – A function to return a color for the links.

  /** @type {Number} [nodeWidth=5] – The width of each node, in pixels, passed to [`sankey.nodeWidth`](https://github.com/d3/d3-sankey#sankey_nodeWidth). */
  export let nodeWidth = 10;

  // /** @type {Number} */
  // export let opacity = 0.1;

  /** @type {Number} [nodePadding=10] – The padding between nodes, passed to [`sankey.nodePadding`](https://github.com/d3/d3-sankey#sankey_nodePadding). */
  // export let nodePadding = 0;
  export let nodePadding = 4;

  /** @type {Function} [linkSort=null] – How to sort the links, passed to [`sankey.linkSort`](https://github.com/d3/d3-sankey#sankey_linkSort). */
  export let linkSort = null;

  /** @type {Function} [nodeId=d => d.id] – The ID field accessor, passed to [`sankey.nodeId`](https://github.com/d3/d3-sankey#sankey_nodeId). */
  export let nodeId = (d) => d.id;

  /** @type {Function} [nodeAlign=d3.sankeyLeft] – An alignment function to position the Sankey blocks. See the [d3-sankey documentation](https://github.com/d3/d3-sankey#alignments) for more. */
  export let nodeAlign = Sankey.sankeyLeft;

  //NODE POSITION PASST NOCH NICHT:
  // HIER KÖNNTE HILFE SEIN:
  // http://bl.ocks.org/KatiRG/90a972bad9109ae556c0
  // http://jsfiddle.net/88Akd/
  // https://stackoverflow.com/questions/21539265/d3-sankey-charts-manually-position-node-along-x-axis

  $: sankey = Sankey.sankey()
    .nodeAlign(nodeAlign)
    .nodeWidth(nodeWidth)
    .nodePadding(nodePadding)
    .nodeId(nodeId)
    .size([$width, $height])
    .linkSort(linkSort);

  // $: sankeyData = sankey($data);
  $: {
    data;
    // console.log('data in sankey: ', data);
    sankeyData = sankey($data);
    setNodeWidth();
    shift_x();
    shiftLeft();
    sticky.forEach((s) => {
      herausfindenWieShiftDownFunktioniert(s);
    });
    shiftDownLinks();
    updateLinkSourceTarget();
  }

  function set_for_node(nodename, attribute, value) {
    var index = 0;
    sankeyData["nodes"].forEach((element) => {
      if (element["id"] == nodename) {
        sankeyData["nodes"][index][attribute] = value;
      }
      index += 1;
    });
  }

  function herausfindenWieShiftDownFunktioniert(nodename) {
    // console.log("sankeyData['links']: ", sankeyData['links']);

    var target_width_sum = 0;

    var index = 0;
    sankeyData["links"].forEach((element) => {
      var y0_source = element["source"]["y0"];

      var y0_target = element["target"]["y0"];
      var y1_target = element["target"]["y1"];

      if (element["source"]["id"] == nodename) {
        var target_heigh = y1_target - y0_target;

        var shift = y0_source + target_width_sum - y0_target;
        set_for_node(element["target"]["id"], "shift_down", shift);
        set_for_node(element["target"]["id"], "y0", y0_source + target_width_sum);
        set_for_node(element["target"]["id"], "y1", y0_source + target_width_sum + target_heigh);
        target_width_sum += y1_target - y0_target;
        // console.log('target_width_sum: ', target_width_sum);
      }

      index += 1;
    });
    // console.log("target_width_sum: ", target_width_sum)
  }

  function setNodeWidth() {
    var index = 0;
    sankeyData["nodes"].forEach((element) => {
      var x0 = element["x0"];

      sankeyData["nodes"][index]["x1"] = x0 + 50;

      index += 1;
    });
  }

  function shift_x() {
    var index = 0;
    sankeyData["nodes"].forEach((element) => {
      if ("shift_x" in element) {
        var shift_x = element["shift_x"];
        sankeyData["nodes"][index]["x0"] += shift_x;
        sankeyData["nodes"][index]["x1"] += shift_x;
      }

      index += 1;
    });
  }

  function updateLinkSourceTarget() {
    var index = 0;
    sankeyData["nodes"].forEach((element) => {
      var node_name = element["id"];
      var x0 = element["x0"];
      var x1 = element["x1"];
      var y0 = element["y0"];
      var y1 = element["y1"];

      var link_index = 0;
      sankeyData["links"].forEach((link) => {
        if (link["source"]["id"] == node_name) {
          sankeyData["links"][link_index]["source"]["x0"] = x0;
          sankeyData["links"][link_index]["source"]["x1"] = x1;
          sankeyData["links"][link_index]["source"]["y0"] = y0;
          sankeyData["links"][link_index]["source"]["y1"] = y1;
        }
        if (link["target"]["id"] == node_name) {
          sankeyData["links"][link_index]["target"]["x0"] = x0;
          sankeyData["links"][link_index]["target"]["x1"] = x1;
          sankeyData["links"][link_index]["target"]["y0"] = y0;
          sankeyData["links"][link_index]["target"]["y1"] = y1;
        }

        link_index += 1;
      });

      index += 1;
    });
  }

  function shiftDownLinks() {
    var index = 0;
    // sankeyData['nodes'].forEach((element) => {
    //   if ('shift_down' in element) {
    //     var shift_down = element['shift_down'];
    //     sankeyData['nodes'][index]['y0'] = sankeyData['nodes'][index]['y0'] + shift_down;
    //     sankeyData['nodes'][index]['y1'] = sankeyData['nodes'][index]['y1'] + shift_down;
    //   }
    //   index += 1;
    // });

    index = 0;
    sankeyData["links"].forEach((element) => {
      if ("shift_down" in element["source"]) {
        var shift_down = element["source"]["shift_down"];
        sankeyData["links"][index]["y0"] = sankeyData["links"][index]["y0"] + shift_down;
        sankeyData["links"][index]["y1"] = sankeyData["links"][index]["y1"] + shift_down;
      }
      index += 1;
    });

    //wenn der source vom Link shift_down drinnen hat => das y0 und y1 vom link verschieben
  }

  function shiftLeft() {
    var index = 0;
    sankeyData["nodes"].forEach((element) => {
      if ("shift_left" in element) {
        var lef_x0 = find_x0_for_node(element["shift_left"]);
        var shift_to_x1 = find_x1_for_node(element["shift_left"]);

        sankeyData["nodes"][index]["x0"] = shift_to_x1;
        sankeyData["nodes"][index]["x1"] = shift_to_x1 + (shift_to_x1 - lef_x0);
      }
      index += 1;
    });
  }

  function find_x1_for_node(name) {
    for (var i = 0; i < sankeyData["nodes"].length; i += 1) {
      // console.log("check ", element['id'])
      if (sankeyData["nodes"][i]["id"] == name) {
        return sankeyData["nodes"][i]["x1"];
      }
    }
    return false;
  }

  function find_x0_for_node(name) {
    for (var i = 0; i < sankeyData["nodes"].length; i += 1) {
      // console.log("check ", element['id'])
      if (sankeyData["nodes"][i]["id"] == name) {
        return sankeyData["nodes"][i]["x0"];
      }
    }
    return false;
  }

  // console.log("sankeyData: ", sankeyData)

  $: link = Sankey.sankeyLinkHorizontal();

  $: fontSize = $width <= 320 ? 6 : 8;

  $: fontSize_small = fontSize - 5;

  function custom_link(d) {
    // console.log("custom_link d: ", d);

    var shift_down = 0;

    if ("shift_down" in d["source"]) {
      if (d["source"]["shift_down"]) {
        shift_down = d["source"]["shift_down"];
      }
    }

    var link_str = link(d);
    var x_str = link(d).split(",", 1)[0];
    x_str = x_str.substring(1);

    // //startpunkt
    // var x = parseFloat(x_str);
    // x = (x + breite);
    // x = d['source']['x1'];
    // link_str = link_str.substring(link_str.indexOf(',') + 1);
    // link_str = 'M' + x.toString() + ',' + link_str;

    // //endpunkt:
    // var x_end_str = link(d).split(',')[5];
    // var x_end = parseFloat(x_end_str);
    // x_end = d['target']['x0'];
    // var link_str_arr = link_str.split(',');
    // link_str_arr[5] = x_end.toString();

    var link_str_arr = link_str.split(",");

    link(d).split(",")[0];
    link(d).split(",")[1];
    link(d).split(",")[2];
    link(d).split(",")[3];
    var y4 = link(d).split(",")[4];
    link(d).split(",")[5];
    var y6 = link(d).split(",")[6];

    y4 = (parseFloat(y4) - shift_down).toString();
    y6 = (parseFloat(y6) - shift_down).toString();

    link_str_arr[4] = y4;
    link_str_arr[6] = y6;

    link_str = link_str_arr.join(",");

    // console.log("data: ", data)

    return link_str;
  }

  function removeLastWord(str) {
    const lastIndexOfSpace = str.lastIndexOf(" ");

    if (lastIndexOfSpace === -1) {
      return str;
    }

    return str.substring(0, lastIndexOfSpace);
  }

  function part_of_word(str, index, y0, y1) {
    var words = str.split(" ");

    if (y1 - y0 < schwellwert_verschiebung) {
      if (index == 0) {
        if (str.includes("%")) {
          var last_word = "(" + words[words.length - 1] + ")";

          return removeLastWord(str) + " " + last_word;
        } else {
          return str;
        }
      } else {
        return "";
      }
    }

    if (words.length > index) {
      return words[index];
    }

    return "";
  }

  function number_split_words(str, y0, y1) {
    if (y1 - y0 >= schwellwert_verschiebung) {
      if (str == "" || str == " ") {
        return 0;
      }
      return str.split(" ").length;
    } else {
      return 1;
    }
  }

  function tausender_trenner(number) {
    if (typeof number == "string") {
      return number;
    }

    // Info: Die '' sind zwei Hochkommas
    number = "" + number;
    if (number.length > 3) {
      var mod = number.length % 3;
      var output = mod > 0 ? number.substring(0, mod) : "";
      var i = 0;
      for (i = 0; i < Math.floor(number.length / 3); i++) {
        if (mod == 0 && i == 0) output += number.substring(mod + 3 * i, mod + 3 * i + 3);
        // hier wird das Trennzeichen festgelegt mit '.'
        else output += "." + number.substring(mod + 3 * i, mod + 3 * i + 3);
      }
      return output;
    } else return number;
  }

  function calc_y_text(y0, y1, extra, id, percentage, absolute) {
    var str = "";
    if (extra && extra != "") {
      str = extra;
    } else {
      str = id;
    }

    var number_of_tspans = number_split_words(str, y0, y1);

    if (y1 - y0 >= schwellwert_verschiebung) {
      if (percentage) {
        number_of_tspans += 1;
      }

      if (absolute) {
        number_of_tspans += 1;
      }
    }

    var verschiebung = number_of_tspans * 6;
    // var verschiebung = 0;

    return (y1 + y0) / 2 - verschiebung;
  }

  function extra_x(y0, y1, extra, absolute, percentage) {
    var verschieben = 0;

    if (y1 - y0 < schwellwert_verschiebung) {
      verschieben = 50;
      var gesamtzahl_buchstaben = extra.length + percentage.length;

      if (gesamtzahl_buchstaben > 5) {
        verschieben += gesamtzahl_buchstaben * 1;
      } else {
        verschieben -= 6;
      }
    }

    return verschieben;
  }
</script>

<!-- in text:

x={(d.x0 < $width / 4 ? d.x1 + 6 : d.x0 - 6)*factor} -->

<div style="position:fixed; top:500px; width:500px; background-color: orange; border: 5px solid; z-index:10;"><button>hallo</button></div>

<g class="sankey-layer" style="z-index: 6;">
  <g class="link-group">
    {#each sankeyData.links as d}
      {#if d.show_link}
        <!-- {#if d.source == "ORG"} -->
        <path d={custom_link(d)} fill="none" stroke={"#FFFFFF"} stroke-opacity="1" stroke-width={d.width + 1} />
        <!-- {/if} -->

        <path d={custom_link(d)} fill="none" stroke={my_link_color(d)} stroke-opacity="1" stroke-width={d.width} />
      {/if}

      {#if "show_link_text" in d && d.show_link_text}
        <text
          x={d.source.x1 + 30}
          y={((d.target.y1 + d.target.y0) / 2 + (d.source.y1 + d.source.y0) / 2) / 2}
          style="fill: #FFFFFF;
              font-size: {fontSize_small}px;
              "
        >
          {d.value}
        </text>
      {/if}
    {/each}
  </g>
  <g class="rect-group">
    {#each sankeyData.nodes as d, i}
      {#if d.absolute > 0}
        <rect
          style="stroke-width:{'stroke-width' in d ? d['stroke-width'] : 3}; stroke:{'stroke' in d ? d['stroke'] : '#16262e'};"
          x={d.x0}
          y={d.y0}
          height={d.y1 - d.y0}
          width={d.x1 - d.x0}
          fill={my_node_color(d)}
        />
        <text
          transform="translate({25 + d.x0 + extra_x(d.y0, d.y1, d.extra, d.absolute, d.percentage)})"
          y={calc_y_text(d.y0, d.y1, d.extra, d.id, d.percentage, d.absolute)}
          width={50}
          style="fill: {'text_color' in d ? (d.y1 - d.y0 < schwellwert_verschiebung ? '#000000' : d['text_color']) : '#4d6659'} ;
              font-size: {fontSize}px;
              "
        >
          {#if !d.extra}
            {@html d.id}
          {:else}
            <tspan text-anchor="middle" x="0" dy="1.2em"
              >{part_of_word(d.extra + " " + tausender_trenner(d.absolute) + " " + d.percentage, 0, d.y0, d.y1)}</tspan
            >
            <tspan text-anchor="middle" x="0" dy="1.2em"
              >{part_of_word(d.extra + " " + tausender_trenner(d.absolute) + " " + d.percentage, 1, d.y0, d.y1)}</tspan
            >
            <tspan text-anchor="middle" x="0" dy="1.2em"
              >{part_of_word(d.extra + " " + tausender_trenner(d.absolute) + " " + d.percentage, 2, d.y0, d.y1)}</tspan
            >
            <tspan text-anchor="middle" x="0" dy="1.2em"
              >{part_of_word(d.extra + " " + tausender_trenner(d.absolute) + " " + d.percentage, 3, d.y0, d.y1)}</tspan
            >
            <tspan text-anchor="middle" x="0" dy="1.2em"
              >{part_of_word(d.extra + " " + tausender_trenner(d.absolute) + " " + d.percentage, 4, d.y0, d.y1)}</tspan
            >
          {/if}
        </text>
      {/if}
    {/each}
  </g>
</g>

<style>
  text {
    pointer-events: none;
  }
</style>
